


















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import MenuEntry from '@/modules/cms/modules/menu/model/MenuEntry'
import { Getter, Mutation, State } from 'vuex-class'
import { MutationTypes } from '@/modules/auth/store/mutation';
import MenuType from '@/modules/cms/modules/menu/model/MenuType';
// import { TreeNode } from 'vue-draggable-nested-tree';

/**
 * Representa un nodo del árbol de menus
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class MenuTreeNode extends Vue {
    @State(state => state.cms.menu.currentMenuItem)
    public currentItem: MenuEntry

    @State(state => state.cms.menu.creatingItem)
    public creatingItem: boolean

    @Mutation('cms/menu/current/item/set')
    public setCurrentItem: (item: MenuEntry) => void

    @Mutation('cms/menu/current/item/delete')
    public deleteItem: (id: string) => void

    @Mutation('cms/menu/TOGGLE_ITEM_SELECTED')
    public toggleItemSelected: (selected: boolean) => void

    @Prop({type: Object, required: true})
    public node: any

    /**
     * Selecciona el elemento para su edición
     */
    public select () {
        this.setCurrentItem(this.item)
        this.toggleItemSelected(true)
    }

    /**
     * Indica si el nodo se encuentra deshabilitado
     */
    public get disabled (): boolean {
        return this.creatingItem
    }

    /**
     * Id temporal del elemento de menu asociado con el nodo
     */
    public get id (): string {
        return this.node.tempId || ''
    }

    /**
     * Indica si el elemento representa un placeholder visual para el nuevo elemento
     */
    public get isNewItemPlaceholder (): boolean {
        return this.node.placeholderForNewItem || false
    }

    /**
     * Id interno del nodo creado por el componente del arbol anidado
     */
    public get nodeId (): string {
        return this.node._id
    }

    /**
     * Elemento
     *
     * Permite acceder a la entidad MenuEntry del árbol
     */
    public get item (): MenuEntry {
        return this.$store.getters['cms/menu/itemOfCurrentMenu'](this.id)
    }

    /**
     * Indica si el elemento actual se esta seleccionado
     */
    public get selected (): boolean {
        return this.currentItem.tempId === this.id
    }

    public open = true

    public toggleOpen () {
        this.open = !this.open
        this.$emit('toggleOpen', this.nodeId)
    }

    /**
     * Indica si el elmento ha sido creado porque es un placeholder
     */
    public get isPlaceholder (): boolean {
        return this.nodeId === 'draggable_tree_drag_placeholder'
    }
}
